import { render, staticRenderFns } from "./ProjectedSavings.vue?vue&type=template&id=d3f36b44&"
import script from "./ProjectedSavings.vue?vue&type=script&lang=js&"
export * from "./ProjectedSavings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports